export default __webpack_public_path__ + "static/media/Spiderman_12.329cb991.png";